import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { apiService } from '../../config/api';

/**
 * ProtectedRoute component for securing admin routes
 * Verifies if the user is authenticated and has admin privileges
 */
const ProtectedRoute = ({ children }) => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const verifyAdminStatus = async () => {
      try {
        // Get token and user from storage
        const token = localStorage.getItem('token');
        const userStr = localStorage.getItem('user');
        
        console.log('ProtectedRoute checking:', { hasToken: !!token, hasUser: !!userStr }); // Debug log
        
        // If no token exists, user is not authenticated
        if (!token) {
          console.log('No token found, redirecting to login'); // Debug log
          setIsAdmin(false);
          setIsLoading(false);
          return;
        }

        // Also check user role from localStorage
        if (userStr) {
          try {
            const user = JSON.parse(userStr);
            console.log('User from localStorage:', user); // Debug log
            if (user.role !== 'admin') {
              console.log('User is not admin, role:', user.role); // Debug log
              setIsAdmin(false);
              setIsLoading(false);
              return;
            }
          } catch (e) {
            console.error('Error parsing user:', e);
          }
        }

        // Verify admin status with backend
        // This makes a test request to a protected admin endpoint
        const response = await apiService.get('/admin/verify');
        console.log('Admin verification response:', response); // Debug log
        if (response && (response.isAdmin === true || response.success === true)) {
          console.log('Admin verified successfully!'); // Debug log
          setIsAdmin(true);
        } else {
          console.log('Admin verification failed, response:', response); // Debug log
          setIsAdmin(false);
        }
      } catch (error) {
        console.error('Admin verification failed:', error);
        console.error('Error details:', error.response?.data); // Debug log
        setIsAdmin(false);
      } finally {
        setIsLoading(false);
      }
    };

    verifyAdminStatus();
  }, [location.pathname]); // Re-verify when location changes

  // Show loading state while checking admin status
  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  // If user is not admin, redirect to adminlogin with the return URL
  if (!isAdmin) {
    return <Navigate to="/adminlogin" state={{ from: location }} replace />;
  }

  // If admin, render the protected content
  return children;
};

export default ProtectedRoute;